import script from "./ViewDefineProps.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDefineProps.vue?vue&type=script&setup=true&lang=js"

import "./ViewDefineProps.vue?vue&type=style&index=0&id=2a9b0c22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9b0c22"]])

export default __exports__